import { useConfirmModal } from "./ConfirmModalContext";
import './ConfirmModal.css'

const ConfirmModal = () => {
  const { modal, closeModal } = useConfirmModal();

  if (!modal.isOpen) return null;

  return (
    <div className="all-confirm-overlay">
      <div className={`all-confirm-modal ${modal.variant === "danger" ? "danger" : ""}`}>
        <h3 className="all-confirm-title">{modal.title}</h3>
        <p className="all-confirm-message">{modal.message}</p>

        <div className="all-confirm-actions">
          <button className="all-btn-cancel"
            onClick={() => {
              if (modal.onCancel) {
                modal.onCancel();
              } else {
                closeModal();
              }
            }}
          >
            {modal.cancelText}
          </button>

          <button
            className={`all-btn-confirm ${modal.variant === "danger" ? "danger" : ""}`}
            onClick={() => {
              modal.onConfirm?.();
              closeModal();
            }}
          >
            {modal.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
